import React from 'react';

const CONTEXT_KEY = Symbol.for('@thd-olt-component-react/product-pod/Context');
const globalSymbols = Object.getOwnPropertySymbols(global);
const hasContext = (globalSymbols.indexOf(CONTEXT_KEY) > -1);

const funcDefault = () => {};

if (!hasContext) {
  global[CONTEXT_KEY] = React.createContext({
    automotiveFitmentObject: null,
    brandMaxLine: null,
    channel: 'desktop',
    env: 'prod',
    itemId: null,
    maxKeyFeatures: 0,
    noATCFulfillment: false,
    onImageClick: funcDefault,
    onCheckNearbyStoresClick: funcDefault,
    onFavoriteClick: funcDefault,
    onOptionClick: funcDefault,
    onOptionMouseEnter: funcDefault,
    onOptionMouseLeave: funcDefault,
    onQuantityChange: funcDefault,
    onRatingClick: funcDefault,
    onVariantClick: funcDefault,
    onCartSucces: funcDefault,
    onCartFailure: funcDefault,
    pageType: null,
    podType: 'default',
    position: 1,
    previewImgUrl: null,
    product: null,
    quantity: 1,
    showVariantAlert: false,
    titleMaxLine: null,
    showDisabledATC: false,
    showAisleAndBay: false
  });
}

export const ProductPodContext = global[CONTEXT_KEY];
